import { constants } from '@/config';

const App = () => import('@/app/youtube/App.vue');
const BoardsIndex = () => import('@/app/boards/pages/BoardsIndex.vue');
const Overview = () => import('@/app/youtube/pages/Overview.vue');
const AnalyticsYourPostsPage = () =>
  import('@/components/core/analytics/AnalyticsYourPostsPage.vue');

const PAGE_LEVEL_TOP = 'YouTube';

export default {
  path: 'youtube',
  component: App,
  meta: {
    requiresAuth: true,
  },
  children: [
    {
      name: 'youtube',
      path: '',
      redirect: { name: 'youtube.overview' },
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Overview`,
      },
    },
    {
      name: 'youtube.overview',
      path: 'overview',
      component: Overview,
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Overview`,
      },
    },
    {
      name: 'youtube.overview.report',
      path: 'overview/report',
      component: Overview,
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Overview Report`,
        report: true,
      },
    },
    {
      path: 'boards',
      children: [
        {
          name: 'youtube.galleries',
          path: '',
          component: BoardsIndex,
          props: {
            galleryType: constants.YOUTUBE,
          },
          meta: {
            analytics: `${PAGE_LEVEL_TOP} - Boards`,
          },
        },
      ],
    },
    {
      name: 'youtube.yourVideos',
      path: 'your-videos',
      component: AnalyticsYourPostsPage,
      props: {
        channel: constants.YOUTUBE,
      },
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Your Videos`,
      },
    },
    {
      name: 'youtube.yourVideos.report',
      path: 'your-videos/report',
      component: AnalyticsYourPostsPage,
      props: {
        channel: constants.YOUTUBE,
      },
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Your Videos Report`,
        report: true,
      },
    },
  ],
};
